import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as yup from 'yup';
import * as approvalApi from '../../../lib/api/approval';
import * as projectApi from '../../../lib/api/project';
import { useDispatch } from 'react-redux';
import { setOrderLetter } from '../../../modules/projectModule/orderAdd';
import OrderBookTemplate from '../../../components/projectmng/obtainorder/OrderBookTemplate';
import ApprovalForm from '../../../components/projectmng/approval/ApprovalForm';

const ApprovalFormContainer = ({ docuCd, user, handleClose }) => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [apprDoc, setApprDoc] = useState(null);
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      docuYn: 'Y',
      docuTxt: '',
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      docuYn: yup
        .string()
        .required('결재 완료여부는 반드시 선택되어야 합니다.'),
    }),
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);
      onSave(values);
      formik.resetForm();
      setSubmitting(false);
      //handleClose();
    },
  });

  const reloadData = async () => {
    setLoading(true);

    try {
      const res = await approvalApi.getCurApprovalDetByCd(docuCd);
      const prjRes = await projectApi.getOrderInfoAll(docuCd);

      if (res.data) {
        dispatch(setOrderLetter(prjRes.data));
        setApprDoc(res.data.list);
      }
    } catch (err) {
      console.log(err);
    }

    setLoading(false);
  };

  const onSave = async (values) => {
    let dataToSubmit = {
      docuCd: docuCd,
      docuUuid: apprDoc.docuUuid,
      docuYn: values.docuYn,
      docuTxt: values.docuTxt,
    };

    try {
      const res = await approvalApi.addOrderDoc(dataToSubmit);
      if (res.data) {
        //reloadData();
        //2023.01.18. 결제 완료 후 결재관리로 이동
        navigate(`/approvalmng`);
      }
    } catch (err) {
      let message =
        err.response !== 'undefined' ? err.response.data.message : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  useEffect(() => {
    //async를 사용하는 함수 따로 선언
    const fetchData = async () => {
      setLoading(true);

      try {
        const res = await approvalApi.getCurApprovalDetByCd(docuCd);

        setApprDoc(res.data.list);
      } catch (err) {
        console.log(err);
      }

      setLoading(false);
    };
    fetchData();
  }, [docuCd]);

  if (loading) {
    return <div>로딩중</div>;
  }

  //아직 값이 없을때
  if (!apprDoc || !user) {
    return null;
  }

  if (apprDoc.docuUsr !== user.usrUuid) {
    //현재 결재자 아님.
    return null;
  }

  //article값이 유효할때
  return (
    <OrderBookTemplate title="결재 확인">
      <ApprovalForm apprDoc={apprDoc} user={user} formik={formik} />
    </OrderBookTemplate>
  );
};

export default ApprovalFormContainer;
